import styled from 'styled-components';

import Visibility from 'assets/images/visibility.svg';
import VisibilityOff from 'assets/images/visibility_off.svg';

const Wrapper = styled.div`
  min-height: 90vh;
  padding: 8vh 16px 8.6vh;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  background-color: #e8e9ea;
  font-family: 'Poppins';

  @media all and (min-height: 1400px) {
    min-height: 93vh;
  }
`;

const InnerWrapper = styled.div`
  width: 368px;
  display: flex;
  flex-flow: column nowrap;
`;

const InputWrapperName = styled(InnerWrapper)`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const InputWrapperConfirm = styled.div`
  width: 368px;
  display: flex;
  align-items: start;
`;

const InnerWrapperSmall = styled(InnerWrapper)`
  width: 168px;
`;

const StepCounter = styled.p`
  display: flex;
  justify-content: center;
  font-size: 14px;
  font-family: 'Eina';
  font-weight: 600;
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 600;
  line-height: 32px;
  margin: 32px 0 32px;
  color: #1c2733;
  text-align: center;
`;

const Form = styled.form`
  margin-bottom: 24px;
`;

const InputWrapper = styled.div`
  margin-bottom: 16px;
  position: relative;

  &:last-of-type {
    margin-bottom: 32px;
  }
`;

const Label = styled.div`
  color: #8b8f93;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.24px;
  line-height: 24px;
  margin: 0 0 8px 0;
`;

const LabelConfirm = styled(Label)`
  display: inline-block;
  font-weight: 400;
`;

const PasswordHint = styled(LabelConfirm)`
  margin-top: 8px;
  color: #1c232c;
  line-height: 17px;
`;

const Input = styled.input`
  border-radius: 4px;
  border: 1px solid #c3c5c7;
  height: 48px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #1c232c;
  transition: border-color 0.2s ease-in-out;

  &:focus {
    border-color: #1c232c;
    outline: none;
  }

  @media (max-width: 680px) {
    font-size: 16px;
  }
`;

const VisibilityIcon = styled.div<{
  isVisible: boolean;
}>`
  position: absolute;
  right: 16px;
  width: 24px;
  height: 24px;
  top: 45px;
  background-color: #b0b3b6;
  mask-image: ${(props) =>
    props.isVisible ? 'url(' + Visibility + ')' : 'url(' + VisibilityOff + ')'};
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  font-size: 1.1em;
  width: 1.1em;
  height: 1.1em;
  cursor: pointer;
  margin-right: 12px;
  transition: 0.3s opacity;
  opacity: 0.5;
`;

const SubmitButton = styled.button<{
  isLoading: boolean;
}>`
  background: linear-gradient(-180deg, rgb(65, 71, 79) 0%, rgb(28, 35, 44) 100%);
  border-radius: 4px;
  height: 64px;
  width: 100%;
  border: none;
  outline: none;
  appearance: none;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins';
  letter-spacing: 0.24px;
  display: block;
  padding: 16px;
  cursor: pointer;
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
  transition: opacity 0.2s ease-in-out;

  &:disabled,
  &[disabled] {
    opacity: 0.5;
  }
`;

const ErrorMessage = styled.p`
  color: #ff263d;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 16px;
  margin: 0 0 16px;
`;

const RegisterText = styled.p`
  font-size: 14px;
  font-weight: 600;
  font-family: 'Eina';
  text-align: center;
  margin-top: 32px;
`;

const RegisterLinkWrapper = styled.span`
  padding-left: 3px;
  text-decoration: underline;
  color: #8b8f93;
`;

const ModalContent = styled.div`
  height: 600px;
  overflow: auto;
  font-family: monospace;
  text-align: left;
  line-height: 1.4;
  font-weight: lighter;
  padding: 10px;
`;

const TermsConditionsBtn = styled.button`
  border: 0px;
  background: none;
`;

const PasswordToolTip = styled.div`
  position: absolute;
  width: 250px;
  left: calc(100% + 10px);
  top: 30px;
`;

export {
  Wrapper,
  ErrorMessage,
  SubmitButton,
  VisibilityIcon,
  Label,
  InnerWrapper,
  InputWrapper,
  Input,
  Form,
  Title,
  StepCounter,
  RegisterText,
  RegisterLinkWrapper,
  InputWrapperName,
  InnerWrapperSmall,
  Checkbox,
  LabelConfirm,
  InputWrapperConfirm,
  PasswordHint,
  ModalContent,
  TermsConditionsBtn,
  PasswordToolTip,
};
